<div id="notfound">
    <div class="notfound">
        <div class="notfound-404"></div>
        <h1>404</h1>
        <h2>You don't have access to this application</h2>		
    </div>
</div>
